const _ = require('lodash');
const ArrayWithExtraFields = require('relevant-shared/misc/arrayWithExtraFields');
const GranularDimensionArr = require('./granularDimensionArr');
const { approxComboCount } = require('./utils');
const { MAX_COMBOS_PER_REPORT_UNIT, CUSTOM_DIM_START_GROUP } = require('./constants');
const { BuiltInCustom, DefaultGranularDims } = require('./defaultGranularDims');

const findBuiltInGroup = (dims) => _(dims)
	.map((dim) => _.find(BuiltInCustom, { hbDim: dim.hbDim }))
	.filter()
	.map('group')
	.min();

/**
 * A set of GranularDimensionArr objects that each are report/updated together.
 * This class should represent the full "sequence" of reports that are used to update HBA-data from API-reports. */
class GranularDimensionSet extends ArrayWithExtraFields {
	onConstructed(customDimGroups) {
		let currDstIdx = CUSTOM_DIM_START_GROUP;
		const arrs = [];
		const add = (idx, dims) => {
			arrs[idx] = arrs[idx] || new GranularDimensionArr(idx ? `group_${idx}` : 'main');
			arrs[idx].push(...dims);
		};
		DefaultGranularDims.forEach((dim) => add(dim.group, [dim]));
		const dimGroups = _.sortBy(customDimGroups, findBuiltInGroup);
		dimGroups.forEach((dims) => {
			// If there are any built-in parameters in group let the lowest group number of these decide position
			const builtInGroup = findBuiltInGroup(dims);
			if (builtInGroup !== undefined) {
				add(builtInGroup, dims);
			} else {
				const nextMulti = approxComboCount(arrs[currDstIdx]) * approxComboCount(dims);
				if (nextMulti > MAX_COMBOS_PER_REPORT_UNIT) {
					currDstIdx++;
				}
				add(currDstIdx, dims);
			}
		});
		const groups = _.filter(arrs).reverse();
		this.setElements(groups);
	}

	approxComboCountMax() {
		return _.max(this.map((arr) => arr.approxComboCount())) || 0;
	}
}

module.exports = GranularDimensionSet;
